import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { HistoricalErpSynchronizationBuilder } from '../../models/builders/historical-erp-synchronization.builder';

@Injectable()
export class HistoricalErpSynchronizationApiService {

  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${environment.apiUrl}historical-erp-synchronization`;
  }

  getLastSyncTime() {
    return this.httpClient.get(`${this.apiUrl}`)
      .pipe(
        map(HistoricalErpSynchronizationBuilder.fromJson)
      );
  }

  postErpSynchronization() {
    return this.httpClient.get(`${this.apiUrl}/sync`);
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/historical-erp-synchronization-api.service.ts